import { Vue } from 'vue-property-decorator'

export const messagingPurpose = () => {
  return {
    ONE_TIME_PAYMENT: { key: 50470001, label: Vue.prototype.$gettext('MESSAGING_PURPOSE.50470001') },
    INSTALLMENT: { key: 50470002, label: Vue.prototype.$gettext('MESSAGING_PURPOSE.50470002') },
    REGULAR_INVOICE: { key: 50470003, label: Vue.prototype.$gettext('MESSAGING_PURPOSE.50470003') },
    NOTICE: { key: 50470004, label: Vue.prototype.$gettext('MESSAGING_PURPOSE.50470004') },
    ADDITIONAL: { key: 50470005, label: Vue.prototype.$gettext('MESSAGING_PURPOSE.50470005') }
  }
}
